import { DateIsoString, dateLocales, defaultDateFormatOptions } from '../entities/Date/Date';
import { Language } from '../entities/Locale/Locale';

interface DateRange {
    start?: Date;
    end?: Date;
}

export const dateIsInRange = (range: DateRange, date = new Date()): boolean => {
    const { start, end } = range;

    if (!start && !end) {
        return true;
    }

    const isPastStart = !start || date > start;
    const isPastEnd = end ? date > end : false;

    return isPastStart && !isPastEnd;
};

export const transformIsoStringToDate = (isoString: string): string => new Date(`${isoString}Z`).toISOString().split('T')[0];

export const calculateDifferenceInDays = (date: Date | string): number => {
    const dateObject = date instanceof Date
        ? date
        : new Date(date);

    const today = new Date();

    const differenceInMilliSeconds = today.getTime() - dateObject.getTime();

    return Math.floor(differenceInMilliSeconds / (1000 * 60 * 60 * 24));
};

export const dateLiesInFuture = (date: Date): boolean => {
    const now = new Date();

    return date.getTime() > now.getTime();
};

export const dateIsWithinOneHour = (date: string): boolean => {
    const now = new Date();
    const then = new Date(date);
    const diffInMs = now.getTime() - then.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);

    return diffInHours < 1;
};

interface FormatDateOptions {
    date?: DateIsoString;
    language?: Language;
    options?: Intl.DateTimeFormatOptions;
}

export const formatDate = ({
    date,
    language = Language.nl,
    options = defaultDateFormatOptions,
}: FormatDateOptions): string => {
    if (!date) {
        return '';
    }

    const locale = dateLocales[language];
    const dateObj = new Date(date);

    return new Intl.DateTimeFormat(locale, options).format(dateObj);
};

export const formatDateAsInputValue = (date: Date = new Date()): string => date.toISOString().split('T')[0];
